import { render } from "./EditEtudiant.vue?vue&type=template&id=571f7760&ts=true"
import script from "./EditEtudiant.vue?vue&type=script&lang=ts"
export * from "./EditEtudiant.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__